"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TableHead = _interopRequireDefault(require("../TableHead"));

var _TableBody = _interopRequireDefault(require("../TableBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableStyled = _styledComponents["default"].table.withConfig({
  componentId: "le865s-0"
})(["table-layout:fixed;width:100%;border-spacing:0;border-collapse:collapse;"]);

function Table(_ref) {
  var className = _ref.className,
      headers = _ref.headers,
      content = _ref.content,
      children = _ref.children;
  return _react["default"].createElement(TableStyled, {
    className: className
  }, _react["default"].createElement(_TableHead["default"], {
    headers: headers
  }), _react["default"].createElement(_TableBody["default"], {
    headers: headers,
    content: content
  }), children);
}

Table.displayName = 'Table';
Table.propTypes = {
  className: _propTypes["default"].string,
  headers: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  content: _propTypes["default"].arrayOf(_propTypes["default"].object),
  children: _propTypes["default"].node
};
Table.defaultProps = {
  className: ''
};

var _default = (0, _react.memo)(Table);

exports["default"] = _default;